import { render, staticRenderFns } from "./TransactionTemplates.vue?vue&type=template&id=8739e704&"
import script from "./TransactionTemplates.vue?vue&type=script&lang=js&"
export * from "./TransactionTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports